module.exports = __webpack_public_path__ + "static/img/mengzhengfile.37018c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mengzhengfile.png
// module id = VIMs
// module chunks = 3